export function maxLengthFromMinLength(minLength) {
    return 2 * minLength + 10;
}
